import moment from 'moment' 
import axios from 'axios' 
import { Pie, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins
 
export default {
  extends: Pie,
  mixins: [reactiveProp],
  //props: [  "options", 'labels', 'height', 'color', 'xdisplay', 'ydisplay', 'gradient', 'symbol',  ],
    props:{
        chartData:{ type : [Array, Object] },
        chartDataName: { type: [String], default: '' },
        labels:{ type : [Array, Object] },
        height:{ type : [Number] },
        color:{ type : [String] },
        symbol:{ type : [String] },
        chartOptions: { 
            type: [Object, Boolean], 
            default: ()=>{
                return {
                    maxTicksLimit: 24,
                    yAxesgridLines: true,
                    xAxesgridLines: true
                }
            }
        },
    },
    data () {
        return {
            chart: false,
        }
    },
    chartData: function() {
      return this.chartData;
    },
    watch: {
        'chartData':{
            deep: true,              
            handler() {
                console.log("watcher")
                console.log(this.chartData)
                //this._chart.update();
                this.init( this.labels, this.chartData)
            }
                
        }
    },
    methods:{
        init( columns, series ){
            
            //console.log("series")
            //console.log(series)
            //console.log( this.chartOptions )
            
            let symbol = this.symbol
      
            let datasets = [
                {
                    label: this.chartDataName,
                    data: series,
                    backgroundColor: [
                        'rgba(255, 99, 132, 0.5)',
                        'rgba(54, 162, 235, 0.5)',
                        'rgba(255, 206, 86, 0.5)',
                        'rgba(75, 192, 192, 0.5)',
                        'rgba(153, 102, 255, 0.5)',
                        'rgba(255, 159, 64, 0.5)',
                        'rgba(255, 99, 132, 0.5)',
                        'rgba(54, 162, 235, 0.5)',
                        'rgba(255, 206, 86, 0.5)',
                        'rgba(75, 192, 192, 0.5)',
                        'rgba(153, 102, 255, 0.5)',
                        'rgba(255, 159, 64, 0.5)',
                    ],
                    borderColor: [
                        'rgba(255, 99, 132, 1)',
                        'rgba(54, 162, 235, 1)',
                        'rgba(255, 206, 86, 1)',
                        'rgba(75, 192, 192, 1)',
                        'rgba(153, 102, 255, 1)',
                        'rgba(255, 159, 64, 1)',
                        'rgba(255, 99, 132, 1)',
                        'rgba(54, 162, 235, 1)',
                        'rgba(255, 206, 86, 1)',
                        'rgba(75, 192, 192, 1)',
                        'rgba(153, 102, 255, 1)',
                        'rgba(255, 159, 64, 1)',
                    ],
                    
                }
            ]
                            
            
            let chartData = { labels: columns, datasets: datasets }

            //console.log( this.options )
            let options = {
                responsive: true, 
                maintainAspectRatio: false,
                legend: {
                    display: false,
                    position: "top",
                    align: 'end',
                    fullWidth: false,
                    labels: {
                        boxWidth: 10,
                        fillStyle: "Color",
                        fontSize: 11
                    },
                    //onClick: this.toggleLegend,
                }, 
            }
            
            this.chart = this.renderChart( chartData, options )
            
        },
        
    },
  mounted () {
      
      this.init( this.labels, this.chartData )
      
  },

}



// WEBPACK FOOTER //
// ./src/components/charts/pieChart.js